import { ZmyleErrorId } from 'utils/constants';
import { getErrorPageContent } from 'services/client/repositories/content';

interface GetErrorContentResponse {
  message: string;
  statusCode: number;
}

export const resolveErrorMessage = async (
  error: ZmyleError,
): Promise<GetErrorContentResponse> => {
  const { status, errorId } = error;

  const content = await getErrorPageContent();

  const {
    noSuchGiftcard,
    requiresAuthentication,
    tooManyRequests,
    genericMessage,

    statusCode400Message,
    statusCode401Message,
    statusCode404Message,
    statusCode429Message,
    statusCode500Message,
    statusCode503Message,
  } = content;

  if (status < 400 || status >= 600) {
    return { statusCode: 500, message: genericMessage };
  }

  type ZmyleErrorIdMessages = {
    [ZmyleErrorId.NO_SUCH_GIFTCARD]: string;
    [ZmyleErrorId.REQUIRES_AUTHENTICATION]: string;
    [ZmyleErrorId.TOO_MANY_REQUESTS]: string;
  };

  const messagesByErrorId: ZmyleErrorIdMessages = {
    [ZmyleErrorId.NO_SUCH_GIFTCARD]: noSuchGiftcard,
    [ZmyleErrorId.REQUIRES_AUTHENTICATION]: requiresAuthentication,
    [ZmyleErrorId.TOO_MANY_REQUESTS]: tooManyRequests,
  };

  const messageById = messagesByErrorId[errorId as keyof ZmyleErrorIdMessages];

  if (messageById) {
    return { statusCode: status, message: messageById };
  }

  const messagesByStatusCode: Record<number, string> = {
    400: statusCode400Message,
    401: statusCode401Message,
    404: statusCode404Message,
    429: statusCode429Message,
    500: statusCode500Message,
    503: statusCode503Message,
  };

  const messageByStatusCode = messagesByStatusCode[status];

  if (messageByStatusCode) {
    return { statusCode: status, message: messageByStatusCode };
  }

  return { statusCode: status, message: genericMessage };
};
